import { Navigate } from 'react-router-dom'

import { useSesion } from '@/modules/auth/useSesion'
import { useSoyDeCampoConEstado } from '@/modules/campo/useSoyDeCampo'
import { PaginaTablero } from '@/modules/tablero/PaginaTablero'
import { Aviso } from '@/shared/ui/Aviso/Aviso'
import { Cargando } from '@/shared/ui/Estados/Cargando'

/**
 * Dónde cae cada quien al entrar.
 *
 * El tablero no es la casa de todo el mundo. El operario no tiene permiso
 * sobre él, y hasta ahora entraba a un «Sin acceso a esta sección» —lo primero
 * que veía al abrir la aplicación era una puerta cerrada—. Va derecho a su
 * trabajo, que es lo único que tiene que hacer aquí.
 */
export function DondeEmpezar() {
  const { puede } = useSesion()
  const { deCampo, resolviendo } = useSoyDeCampoConEstado()

  if (puede('tablero', 'ver')) return <PaginaTablero />

  // Bodega y cartera no tienen tablero: entran directo a su área (0246).
  if (puede('bodega', 'ver')) return <Navigate to="/bodega/alistamientos" replace />
  if (puede('cartera', 'ver')) return <Navigate to="/financiera/cartera" replace />

  // Todavía no se sabe: se espera, pero solo mientras de verdad se está preguntando.
  if (resolviendo) return <Cargando mensaje="INICIANDO SISTEMA CENTRAL..." />

  if (deCampo) return <Navigate to="/mi-trabajo" replace />

  return (
    <Aviso tipo="alerta" titulo="Su usuario todavía no tiene a dónde entrar">
      No tiene acceso al tablero y no está vinculado a un colaborador que salga a campo, así que
      no hay pantalla de inicio que mostrarle. No es algo que usted pueda arreglar desde aquí:
      pídale a administración que revise su ficha de colaborador.
    </Aviso>
  )
}
